import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

const { colors, spacing, typography } = THEME;

export const aiEmailStepFormStyles = StyleSheet.create({
	promptTextArea: {
		minHeight: 120,
		fontFamily: typography.fontFamilies.lexend,
	},
	description: {
		color: colors.text.light,
		fontSize: typography.fontSizes.xs,
		marginTop: spacing.xs,
	},
	characterCount: {
		color: colors.text.light,
		display: 'block',
		fontSize: typography.fontSizes.xs,
		marginTop: spacing.xs,
		textAlign: 'right',
	},
	characterCountOverLimit: {
		color: colors.danger.main,
	},
});
